export default [
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/pages/cloudx/administration/Settings.vue'),
    },
]
